import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  useTheme,
  MenuItem,
  Select,
  InputLabel,
  FormControl
} from '@mui/material';
import { addCredential, CredentialInput } from '../../../networkRequest/officialsService';
import { useUser } from '../../../hooks/useUser';
import SecondaryButton from '../../../components/buttons/SecondaryButton';
import PrimaryButton from '../../../components/buttons/PrimaryButton';
import DOMPurify from 'dompurify';
import { CREDENTIAL_TYPES, getCredentialTypeDisplayName } from '../../../utils/credential';

type CredentialDialogProps = {
  open: boolean;
  officialId: number;
  onClose: () => void;
  onSubmit?: (formData: CredentialInput) => void;
  onError: (error: string) => void;
};

export const AddCredentialDialog = ({
  open,
  officialId,
  onClose = () => {},
  onSubmit = () => {},
  onError
}: CredentialDialogProps) => {
  const { user } = useUser();
  const theme = useTheme();
  const padding = theme.spacing(4);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!user) {
      throw new Error('User not found');
    }
    const type = (e.currentTarget.elements.namedItem('type') as HTMLSelectElement)?.value;
    const sanitizedType = DOMPurify.sanitize(type);
    const response = await addCredential(user.accessToken, officialId, {
      credential_type: sanitizedType
    });
    if (response.error) {
      onError(response.error);
    } else if (response.data) {
      onSubmit?.(response.data);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      slotProps={{ paper: { style: { borderRadius: 8 } } }}
    >
      <form onSubmit={handleSubmit} role="form">
        <DialogTitle sx={{ padding }}>Add Credential</DialogTitle>
        <DialogContent sx={{ padding }}>
          <Grid container spacing={3} sx={{
            padding: 1
          }}>
            <Grid size={12}>
              <FormControl fullWidth variant="outlined" required>
                <InputLabel id="credential-type-label">Credential Type</InputLabel>
                <Select
                  name="type"
                  labelId="credential-type-label"
                  id="credential-type-select"
                  label="Credential Type"
                  defaultValue={'mobile'}
                  fullWidth
                >
                  {CREDENTIAL_TYPES.map((credentialType) => (
                    <MenuItem key={credentialType} value={credentialType}>
                      {getCredentialTypeDisplayName(credentialType)}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ padding, pt: 0, mr: 1 }}>
          <SecondaryButton action={onClose}>Cancel</SecondaryButton>
          <PrimaryButton type="submit" disabled={false} loading={false}>
            Save Changes
          </PrimaryButton>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default AddCredentialDialog;
